import { render } from "./TokenTY.vue?vue&type=template&id=54cd6227&scoped=true"
import script from "./TokenTY.vue?vue&type=script&lang=js"
export * from "./TokenTY.vue?vue&type=script&lang=js"

import "./TokenTY.vue?vue&type=style&index=0&id=54cd6227&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54cd6227"]])

export default __exports__